import React from 'react'
import classNames from 'classnames'

import {ReactComponent as NewIcon} from 'assets/icons/badge/Lightning.svg'
import {ReactComponent as SpecialOfferIcon} from 'assets/icons/badge/Sale.svg'
import {ReactComponent as SeasonOfferIcon} from 'assets/icons/badge/Star.svg'
import {ReactComponent as SalesHitIcon} from 'assets/icons/badge/Fire.svg'


import styles from './styles/badge.module.scss'

const Badge = ({ badgeType }) => {
  const LABEL = {
    new: 'Новинка',
    special_offer: 'Акция',
    seasonal_offer: 'Сезонное предложение',
    sales_hit: 'Хит продаж',
  }

  const ICON = {
    new: <NewIcon />,
    special_offer: <SpecialOfferIcon/>,
    seasonal_offer: <SeasonOfferIcon/>,
    sales_hit: <SalesHitIcon/>,
  }

  const badgeClasses = classNames({
    [styles.badge]: true,
    [styles[`badge--${badgeType}`]]: true
  })
  return (
    <div className={badgeClasses}>
      {ICON[badgeType]}
      <span className={styles.badge__text}>
        {LABEL[badgeType]}
      </span>
    </div>
  )
}

export default Badge